import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Modal from '../../Modal/Modal';
import styles from './JoinRequestModal.module.scss';
import RequestNotification from './RequestNotification/RequestNotification';
import { useTranslation } from 'react-i18next';
import Paragraph from '../../Typography/Paragraph/Paragraph';
const JoinRequestModal = ({ closeModal, requests, guildInfo }) => {
    const { t } = useTranslation();
    return (_jsxs(Modal, Object.assign({ className: styles.element, closeModal: closeModal }, { children: [_jsx(Paragraph, { fontFamily: 'urbanist', color: 'grey', className: styles.heading, title: `${t('join_requests')} ${guildInfo.name}`, size: 4 }), requests.length ? (_jsx(RequestNotification, { guildInfo: guildInfo, data: requests })) : (_jsx(Paragraph, { size: 4, className: styles.request, title: t('no_more_request') }))] })));
};
export default JoinRequestModal;
